import "./InvestorsMedia.module.css";
import Header from "@/reusable_sections/Header";
import InvestorMaterials from "./sections/InvestorMaterials";
import NewsMedia from "./sections/NewsMedia";
import ContactIrForm from "./sections/ContactIrForm";
import Footer from "@/reusable_sections/Footer";
export default function InvestorsMediaPage() {
  return <div>
      <Header />
      <InvestorMaterials />
      <NewsMedia />
      <ContactIrForm />
      <Footer />
    </div>;
}